import isMobile from '@/mixins/displayAdaptable';

export default {
  mixins: [isMobile],
  computed: {
    actionIcon() {
      return this.isMobile() ? 'mx-1 pa-3' : 'mx-1 pa-2';
    },
  },
};
